module.exports = __webpack_public_path__ + "img/Comic_45.082b61cb.png";